import './assets/main.css'
import 'primeicons/primeicons.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import PrimeVue from 'primevue/config'
import MyPreset from './services/primeVueConf.ts';
import { useSentry } from './services/sentry'

import App from './App.vue'
import router from './router'

import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip'
import { useUsers } from '@/features/users/controller'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
useSentry(app, router)
app.use(pinia)
app.use(router)

app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: '.app-dark',
            // cssLayer: false
        },
    },
    locale: {
        startsWith: 'Commence avec',
        contains: 'Contient',
        notContains: 'Ne contient as',
        endsWith: 'Fini avec',
        equals: 'Égale',
        notEquals: 'Non égale',
        noFilter: 'Pas de filtre',
        lt: 'Inférieur à',
        lte: 'Inférieur ou égal à',
        gte: 'Supérieur ou égal à',
        dateIs: 'La date est',
        dateIsNot: 'La date n\'est pas',
        dateBefore: 'La date est antérieure',
        dateAfter: 'La date est après',
        clear: 'Supprimer',
        apply: 'Appliquer',
        matchAll: 'Tout faire correspondre',
        matchAny: 'Correspond à n\'importe quel',
        addRule: 'Ajouter une règle',
        removeRule: 'Supprimer la règle',
        accept: 'Accepter',
        reject: 'Refuser',
        choose: 'Choisir',
        upload: 'Télécharger',
        cancel: 'Annuler',
        pending: 'En attente',
        dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
        dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
        monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Dec'],
        chooseYear: 'Choisissez l\'année',
        chooseMonth: 'Choisissez le mois',
        chooseDate: 'Choisissez la date',
        prevDecade: 'Décennie précédente',
        nextDecade: 'Décennie suivante',
        prevYear: 'Année précédente',
        nextYear: 'Année suivante',
        prevMonth: 'Mois précédent',
        nextMonth: 'Mois suivant',
        prevHour: 'Heure précédente',
        nextHour: 'Heure suivante',
        prevMinute: 'Minute précédente',
        nextMinute: 'Minute suivante',
        prevSecond: 'Seconde précédente',
        nextSecond: 'Seconde suivante',
        today: 'Aujourd\'hui',
        weekHeader: 'Wk',
        firstDayOfWeek: 1,
        showMonthAfterYear: false,
        dateFormat: 'dd/mm/yy',
        weak: 'Faible',
        medium: 'Moyen',
        strong: 'Fort',
        passwordPrompt: 'Entrez un mot de passe',
        searchMessage: '{0} résultats disponibles',
        selectionMessage: '{0} éléments sélectionnés',
        emptySelectionMessage: 'Aucun élément sélectionné',
        emptySearchMessage: 'Aucun résultat trouvé',
        fileChosenMessage: '{0} fichiers',
        noFileChosenMessage: 'Aucun fichier choisi',
        emptyMessage: 'Aucune option disponible',
    }
})

app.directive('tooltip', Tooltip)
app.use(ToastService);

app.mount('#app')
